import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { CONTACT } from '@common/constants';

import { Electrical } from '@modules/services/electrical/Electrical';

const TITLE = 'Expert Electrical Services London | Qeeper';
const DESC = `Need electrical services in London? Book our emergency electricians for fast, reliable service - from routine maintenance to urgent repairs.  ${CONTACT.PHONE}`;

const URL = 'https://www.qeeper.co.uk/services/electrical';

const SEO_KEYWORDS =
  'emergency electricians, emergency electrician london, book an electrician, electrical services london, emergency electrician near me, eirc, electrical installation condition report certificate, portable appliance test';

const PlumbingPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <Electrical />
    </>
  );
};

export default PlumbingPage;
